<template>
  <button
    id="btn-project-pool"
    class="btn-innovation btn-innovation-left bg-orange d-lg-inline-block tooltipper"
    @click.stop="onClickProjectPool"
    title="Kurum İçi Girişimcilik Programı kapsamında değerlendirilmesini istediğin yeni iş fikirlerini buradan iletebilirsin."
  >
    {{ userDetail.CompanyConfiguration.SharePointSuggestionButtonText }}
    <span class="icon-right"></span>
    <span
      style="
        color: #fff;
        font-size: 11px;
        display: block;
        opacity: 78%;
        font-weight: 400;
      "
      >Tüm Yılların Projelerine Ulaşabilirsiniz</span
    >
    <img
      src="../../assets/images/fuzeicon.png"
      alt="Fikrini Paylaş"
      style="
        padding-right: 40px;
        position: absolute;
        right: 0;
        top: 5px;
        max-width: 100%;
        max-height: 100%;
      "
    />
  </button>
</template>

<script>
export default {
  name: "ProjectpoolBtn",
  props: ["userDetail"],
  methods: {
    onClickProjectPool() {
      this.$emit("on-click-project-pool");
    },
  },
};
</script>